import { Link } from "react-router-dom";
import { events } from "@/mocks/events";
import EventCard from "@/components/feature/EventCard";

export default function LatestGrid() {
  const latest = [...events].slice(0, 6);

  return (
    <section className="bg-background-100/70">
      <div className="container-x py-12 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-video-add-line"></i>
              持续更新
            </span>
            <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新吃瓜视频
            </h2>
          </div>
          <Link
            to="/events"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            更多热点
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((item) => (
            <EventCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}